
export const TIMESERIES_TOP_ORDER = {
  avg: 'avg',
  max: 'max'
} as const;

export const DELETED_ITEMS = {
  hide: 'hide', compact: 'compact', show: 'show'
} as const;